export default "__VITE_ASSET__Dr9tx$Qr__"